export default __webpack_public_path__ + "static/media/background2.43cce149.svg";